import { convertRemoteToDesignSystemRole, } from "../enums/SDKDesignSystemRole";
export class DesignSystemMemberList {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.users = model.members.map((m) => {
            return {
                userId: m.userId,
                designSystemRole: m.designSystemRole
                    ? convertRemoteToDesignSystemRole(m.designSystemRole)
                    : null,
            };
        });
        this.invitations = model.invitations.map((i) => {
            return {
                id: i.id,
                workspaceInvitationId: i.workspaceInvitationId,
                designSystemRole: i.designSystemRole
                    ? convertRemoteToDesignSystemRole(i.designSystemRole)
                    : null,
            };
        });
    }
}
